import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/cr";

const RuntimeContext = createContext({ is_desktop: false, version: "", loading: true });

export function RuntimeProvider({ children }) {
  const [runtime, setRuntime] = useState({ is_desktop: false, version: "", loading: true });
  useEffect(() => {
    let cancelled = false;
    api.get("/runtime")
      .then((r) => { if (!cancelled) setRuntime({ ...r.data, loading: false }); })
      .catch(() => { if (!cancelled) setRuntime({ is_desktop: false, version: "", loading: false }); });
    return () => { cancelled = true; };
  }, []);
  return <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>;
}

export function useRuntime() {
  return useContext(RuntimeContext);
}
